<template>
  <div
    v-ripple="'rgb(175, 223, 211, 0.15)'"
    :style="{
      height,
      borderTop: noTopBorder ? '' : border,
      borderBottom: last ? border : '',
      backgroundColor: highlighted ? '#D9F0EA' : '',
      color: highlighted ? '#E05484' : null
    }"
  >
    <img
      v-if="icon"
      :src="require('@/assets/icons/' + icon)"
      :class="[{ 'pull-right': iconRight, icon: true }, iconClass]"
    />
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DetailListItem",
  props: {
    noTopBorder: { default: false },
    border: { default: "1px solid #afdfd3" },
    last: { default: false },
    highlighted: { default: false },
    height: { default: "3rem" },
    iconRight: Boolean,
    icon: {},
    iconClass: { type: String, default: "" }
  },
  data: function() {
    return {};
  }
};
</script>

<style scoped>
div {
  display: block;
  width: 100%;
  text-align: left;
  line-height: 3rem;
  cursor: pointer;
  padding-left: 1rem;
}

div:hover {
  background-color: #fafafa;
}

.icon {
  width: 30px;
  vertical-align: middle;
}

.pull-right {
  float: right;
  height: 3rem;
  margin-right: 1rem;
}
</style>
